<template>
  <div class="jump-config">
    <el-form-item label="跳转类型">
      <el-select v-model="row.url_type" clearable placeholder="不跳转（纯展示）" @change="onTypeChange">
        <el-option v-for="t in typeOptions" :key="t.value" :label="t.label" :value="t.value"></el-option>
      </el-select>
      <p v-if="row.url_type == 1" class="font-12 color-999 tip">
        选到「首页 / 资讯 / 我的 / 积分商城 / 项目咨询」这几个 tabbar 页面时，小程序走的是
        reLaunch，会清空页面栈 —— 用在渠道落地页里，用户就回不到落地页了。
      </p>
      <p v-if="row.url_type == 7" class="font-12 color-999 tip">客服不需要再配任何内容。</p>
    </el-form-item>

    <!-- 1 链接：只给内页白名单，不让手填 -->
    <el-form-item v-if="row.url_type == 1" label="链接地址">
      <el-select v-model="row.url" placeholder="请选择" filterable>
        <el-option v-for="u in urlList" :key="u.value" :label="u.label" :value="u.value"></el-option>
      </el-select>
    </el-form-item>

    <!-- 2 富文本：标题是必须的，小程序拿它当富文本页的标题栏文案 -->
    <template v-if="row.url_type == 2">
      <el-form-item label="富文本标题">
        <el-input v-model="row.name" maxlength="100" show-word-limit placeholder="会作为富文本页的标题"></el-input>
      </el-form-item>
      <el-form-item label="富文本内容">
        <!-- name 给 UEditor 当 id 种子，每个 jumpConfig 实例一个，避免同页多个编辑器撞 id -->
        <wangEditorTool ref="editor" :name="editorName" :content="row.text" />
      </el-form-item>
    </template>

    <!-- 4 视频 -->
    <el-form-item v-if="row.url_type == 4" label="选择视频">
      <el-button class="avatar-uploader video" @click="videoVisible = true">
        <video v-if="row.movie" width="178px" controls>
          <source :src="row.movie" />
        </video>
        <i v-if="row.movie" class="el-icon-delete" @click.stop="row.movie = null"></i>
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-button>
    </el-form-item>

    <!-- 5 商品 / 6 项目 / 8 秒杀 / 10 资讯 / 12 自定义活动页：都是"选一个实体" -->
    <el-form-item v-if="isEntityType" :label="entityLabel">
      <el-button type="text" @click="openEntityDialog">
        {{ row.jump_target_name ? '修改' + entityLabel.replace('选择', '') : '+ ' + entityLabel }}
      </el-button>
      <div v-if="row.jump_target_name" class="picked">
        {{ row.jump_target_name }}
      </div>
      <p v-else class="font-12 color-999 tip">还没选，保存时会被拦下。</p>
    </el-form-item>

    <!-- 9 外部小程序：两个字段都要填，小程序端是 || 守卫，少一个就跳不了 -->
    <template v-if="row.url_type == 9">
      <el-form-item label="小程序AppId">
        <el-input v-model="row.mini_appid" placeholder="外部小程序的 appid"></el-input>
      </el-form-item>
      <el-form-item label="页面地址">
        <el-input v-model="row.mini_page" placeholder="外部小程序的页面路径"></el-input>
      </el-form-item>
    </template>

    <!-- 11 专题 -->
    <el-form-item v-if="row.url_type == 11" label="选择专题">
      <el-cascader
        v-model="row.catetory_uuid"
        :show-all-levels="false"
        :emitPath="false"
        :options="categoryOptions"
        :props="cascaderProps"
        filterable
        collapse-tags
        @change="onCategoryChange"
      ></el-cascader>
    </el-form-item>

    <!--
      实体选择弹窗：商品 / 项目 / 秒杀，直接复用仓里现成的三个。
      ⚠ 两件事，缺一个都会出问题：

      1) `v-if` 是必须的，不能只靠 dialogVisible。这三个组件在模板里是**顶层元素**，
         不在 el-dialog 里（el-dialog 内部有 v-if="rendered" 才是懒的），而它们
         created 里就 getList()，selectCommdity 还是 page_size=9999 全量拉商品。
         一个 20 张图的组件 = 60 个请求。而且它们内部是内联 axios + 写死
         https://time.api.boyalife.cn，开发环境下会直接打生产。
      2) `@closeDialog` 复位也是必须的。它们靠 dialogVisible 的 false→true 变化打开，
         自己关掉(点 X / 取消)时不改回 prop，不复位就会"关掉之后再点选择按钮没反应"
         —— addBanner.vue 至今是这个毛病。
    -->
    <selectCommdity
      v-if="commodityMounted"
      :dialogVisible="commodityVisible"
      :isSingle="true"
      @confirmCommidity="onPickCommodity"
      @closeDialog="commodityVisible = false"
    />
    <selectProject
      v-if="projectMounted"
      :dialogVisible="projectVisible"
      :isSingle="true"
      @confirmProject="onPickProject"
      @closeDialog="projectVisible = false"
    />
    <selectSeckill
      v-if="seckillMounted"
      :dialogVisible="seckillVisible"
      :isSingle="true"
      @confirmCommidity="onPickSeckill"
      @closeDialog="seckillVisible = false"
    />

    <!-- 资讯 -->
    <el-dialog title="选择资讯" :visible.sync="informationVisible" append-to-body :close-on-click-modal="false">
      <el-input v-model="informationKeyword" placeholder="请输入资讯标题" @input="searchInformation">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <el-table :data="informationTable.data" border class="mg-t-10">
        <el-table-column width="55" :align="'center'">
          <template slot-scope="scope">
            <el-radio v-model="informationPickedUuid" :label="scope.row.uuid"><span></span></el-radio>
          </template>
        </el-table-column>
        <el-table-column property="information_title" label="资讯标题"></el-table-column>
      </el-table>
      <pagination
        :total="informationTable.total"
        :per_page="informationTable.per_page"
        :current_page="informationTable.current_page"
        @handleCurrentChange="onInformationPage"
        @handleSizeChange="onInformationSize"
      />
      <span slot="footer">
        <el-button size="mini" @click="informationVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirmInformation">确定</el-button>
      </span>
    </el-dialog>

    <!-- 自定义活动页(url_type=12) -->
    <el-dialog title="选择活动页" :visible.sync="activityPageVisible" append-to-body :close-on-click-modal="false">
      <el-input v-model="activityPageKeyword" placeholder="请输入活动页标题" @input="searchActivityPages">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <el-table :data="activityPageTable.data" border class="mg-t-10">
        <el-table-column width="55" :align="'center'">
          <template slot-scope="scope">
            <el-radio v-model="activityPagePickedUuid" :label="scope.row.uuid" :disabled="scope.row.uuid === selfPageUuid">
              <span></span>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column property="title" label="页面标题"></el-table-column>
        <el-table-column label="状态" width="100" :align="'center'">
          <template slot-scope="scope">
            <span>{{ scope.row.is_online == 1 ? '在架' : '未在架' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <p class="font-12 color-999 tip">当前正在编辑的这个页面不能选（会变成点自己跳自己）。</p>
      <pagination
        :total="activityPageTable.total"
        :per_page="activityPageTable.per_page"
        :current_page="activityPageTable.current_page"
        @handleCurrentChange="onActivityPagePage"
        @handleSizeChange="onActivityPageSize"
      />
      <span slot="footer">
        <el-button size="mini" @click="activityPageVisible = false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirmActivityPage">确定</el-button>
      </span>
    </el-dialog>

    <!-- 视频素材库 -->
    <el-dialog title="选择视频" :visible.sync="videoVisible" width="80%" append-to-body :close-on-click-modal="false">
      <MaterialLibrary type="chooseVideo" @insertVideoHandler="onPickVideo" />
      <span slot="footer" class="text-center">
        <el-button @click="videoVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import MaterialLibrary from './materialLibraryDialog/index'
  import wangEditorTool from './wangEditorTool.vue'
  import selectCommdity from './selectCommdity'
  import selectProject from './selectProject.vue'
  import selectSeckill from './selectSeckill.vue'
  import pagination from './pagination.vue'
  import { emptyRow } from './jumpRow'

  /**
   * 跳转配置 —— 一处配「跳转类型 + 对应内容」。
   *
   * 为什么新写一个而不是抽现有的：仓里这套枚举有**四份**副本
   * (addBanner / addAdvertise / miniProgramPageConfig / addRecommonPosition)，
   * 而且语义已经漂移过 —— 内页链接一个绑 url 一个绑 mini_page、urlList 条数和中文名
   * 都不一样、addAdvertise 一条校验都没有。先裁决谁对再抽组件，风险和收益不成比例。
   * 所以：**只给新功能用这一份干净的，存量四处一行不动**，等它跑稳了再逐个替换。
   *
   * 用法（注意是**就地改** row，不是 v-model）：
   *   <jumpConfig :row="image" :self-page-uuid="pageUuid" />
   * row 必须是一个**所有键都已存在**的对象（Vue 2 的响应式限制），用
   * jumpConfig.emptyRow() 造。
   *
   * 富文本内容不在 row 上双向绑定 —— wangEditorTool 是 ref 取值的，
   * 提交前父组件要调 collect() 把编辑器内容回写进 row。
   */
  export default {
    name: 'jumpConfig',
    components: { MaterialLibrary, wangEditorTool, selectCommdity, selectProject, selectSeckill, pagination },
    props: {
      row: {
        type: Object,
        required: true
      },
      // 默认排除 3(小程序页面)：小程序的 $redirectBanner 没有 type 3 的分支也没有 else，
      // 存进去是个哑弹 —— 用户点了静默什么都不发生，连 toast 都没有。后端也会拒。
      excludeTypes: {
        type: Array,
        default: () => [3]
      },
      // 当前正在编辑的活动页 uuid，用来在 12 的选择弹窗里禁掉"选自己"
      selfPageUuid: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        // 编号沿用 banner.url_type。7 是**客服**不是外部链接 —— 别照记忆写。
        allTypes: [
          { value: 1, label: '链接' },
          { value: 2, label: '富文本' },
          { value: 3, label: '小程序页面' },
          { value: 4, label: '视频' },
          { value: 5, label: '商品' },
          { value: 6, label: '项目' },
          { value: 7, label: '客服' },
          { value: 8, label: '秒杀' },
          { value: 9, label: '外部小程序' },
          { value: 10, label: '资讯' },
          { value: 11, label: '专题' },
          { value: 12, label: '自定义活动页' }
        ],
        // 照 addBanner.vue:482-535 那份(13 条，是两份里更全的)。
        // addAdvertise.vue 那份只有 10 条且中文名不同，不要拿来混用。
        urlList: [
          { label: '会员中心', value: '/myPage/vip/benefit/benefit' },
          { label: '会员权益', value: '/vipPage/rights/rights' },
          { label: '签到', value: '/myPage/vip/sign/sign' },
          { label: '项目咨询（项目列表）', value: '/mallPage/mall/mall?current=1' },
          { label: '积分商城', value: '/mallPage/mall/mall?current=0' },
          { label: '我的卡券', value: '/myPage/wallet/coupons/coupons' },
          { label: '任务中心', value: '/vipPage/meberTask/meberTask' },
          { label: '关于博雅', value: '/vipPage/about/about' },
          { label: '首页', value: '/pages/index/index' },
          { label: '资讯', value: '/pages/information/information' },
          { label: '我的', value: '/pages/my/my' },
          { label: '宠物列表', value: '/myCellPage/petPackage/petPackage' },
          { label: '敬请期待', value: '/myCellPage/beingDeveloped/beingDeveloped' }
        ],
        categoryOptions: [],
        cascaderProps: {
          label: 'category_name',
          value: 'uuid',
          children: 'children',
          checkStrictly: true
        },
        // xxxMounted 控制"要不要把这个弹窗组件挂上去"(挂上去它就会发请求)，
        // xxxVisible 控制"要不要展开"。分成两个是因为这些组件的 visible 只能靠
        // dialogVisible 的 false→true 变化驱动 —— 挂上去的那一刻 prop 就已经是
        // true 的话，watcher 不会触发，弹窗永远打不开。
        commodityMounted: false,
        commodityVisible: false,
        projectMounted: false,
        projectVisible: false,
        seckillMounted: false,
        seckillVisible: false,
        videoVisible: false,
        informationVisible: false,
        informationKeyword: '',
        informationPickedUuid: '',
        informationTable: { data: [], per_page: 10, current_page: 1, total: 0 },
        activityPageVisible: false,
        activityPageKeyword: '',
        activityPagePickedUuid: '',
        activityPageTable: { data: [], per_page: 10, current_page: 1, total: 0 }
      }
    },
    computed: {
      typeOptions() {
        return this.allTypes.filter(t => this.excludeTypes.indexOf(t.value) === -1)
      },
      isEntityType() {
        return [5, 6, 8, 10, 12].indexOf(Number(this.row.url_type)) !== -1
      },
      entityLabel() {
        return {
          5: '选择商品',
          6: '选择项目',
          8: '选择秒杀',
          10: '选择资讯',
          12: '选择活动页'
        }[Number(this.row.url_type)] || ''
      },
      // UEditor 的 id 种子，每个 jumpConfig 实例唯一
      editorName() {
        return 'jump_' + this._uid
      }
    },
    created() {
      if (Number(this.row.url_type) === 11) this.loadCategories()
    },
    methods: {
      /**
       * 提交前由父组件调用：把富文本内容回写进 row。不调就会存成空富文本。
       *
       * ⚠ 为什么不直接读 wangEditorTool 的 `html`：那是个**计算属性**
       *   (wangEditorTool.vue:98-103 → uEditorTool.vue:26-28)，最终调的是
       *   `ueditor.getContent()` —— 一个非响应式的方法。所以它求值一次之后就被
       *   缓存住了，**第二次保存拿到的是第一次的内容**。
       *   仓里别的页面碰不到，是因为它们保存完就 $router.go(-1) 走人；这个页面
       *   保存后是留在原地继续编辑的，正好踩上。
       *   所以这里绕过计算属性，直接问 UE 实例要。拿不到才退回 `html`。
       */
      collect() {
        if (Number(this.row.url_type) !== 2) return this.row
        const tool = this.$refs.editor
        if (!tool) return this.row

        let html = ''
        const ue = tool.$refs.ueditorRef
        if (ue && ue.ueditor && typeof ue.ueditor.getContent === 'function') {
          html = ue.ueditor.getContent()
        } else {
          html = tool.html
        }
        if (html && html !== '<p><br></p>') this.row.text = html
        return this.row
      },

      onTypeChange(type) {
        // 换类型时把上一种类型的残留清掉 —— 否则库里会留下"选了商品又选了资讯"
        // 这种自相矛盾的行，界面上还看不出来。
        // ⚠ caption 要留着：它是「图下方的说明文字」，跟跳转类型没关系。
        //   它在 emptyRow() 里只是为了让 edit.vue 的 pickJump 别漏掉它，
        //   跟着一起清掉的话，运营改个跳转类型说明文字就没了。
        const keep = ['url_type', 'caption']
        Object.keys(emptyRow()).forEach(key => {
          if (keep.indexOf(key) === -1) this.row[key] = null
        })
        if (Number(type) === 11) this.loadCategories()
      },

      // 先挂载、下一帧再展开，让子组件的 dialogVisible watcher 能看到 false→true
      openLazyDialog(key) {
        this[key + 'Mounted'] = true
        this.$nextTick(() => {
          this[key + 'Visible'] = true
        })
      },

      openEntityDialog() {
        const type = Number(this.row.url_type)
        if (type === 5) this.openLazyDialog('commodity')
        if (type === 6) this.openLazyDialog('project')
        if (type === 8) this.openLazyDialog('seckill')
        if (type === 10) {
          this.informationPickedUuid = this.row.information_uuid || ''
          this.informationVisible = true
          this.loadInformation()
        }
        if (type === 12) {
          this.activityPagePickedUuid = this.row.activity_page_uuid || ''
          this.activityPageVisible = true
          this.loadActivityPages()
        }
      },

      /**
       * ⚠ 这三个弹窗在 isSingle=true 时 emit 出来的是**一个对象**，不是数组
       *   （selectCommdity.vue:179-191 —— `this.selectRows = rows[rows.length - 1]`）。
       *   照数组写 rows[0] 会永远拿到 undefined，表现是"选完点确定，什么都没发生"。
       *   addBanner.vue:865 用的就是 `v.uuid`。这里两种形态都兜住。
       */
      pickOne(payload) {
        if (Array.isArray(payload)) return payload[payload.length - 1]
        return payload
      },
      onPickCommodity(payload) {
        const picked = this.pickOne(payload)
        this.commodityVisible = false
        if (!picked || !picked.uuid) return
        this.row.goods_uuid = picked.uuid
        this.row.jump_target_name = picked.name
      },
      onPickProject(payload) {
        const picked = this.pickOne(payload)
        this.projectVisible = false
        if (!picked || !picked.uuid) return
        this.row.item_uuid = picked.uuid
        this.row.jump_target_name = picked.name
      },
      onPickSeckill(payload) {
        const picked = this.pickOne(payload)
        this.seckillVisible = false
        if (!picked || !picked.uuid) return
        this.row.miaosha_uuid = picked.uuid
        this.row.jump_target_name = picked.name
      },
      onPickVideo(url) {
        this.row.movie = url
        this.videoVisible = false
      },
      onCategoryChange(uuid) {
        const found = this.findCategory(this.categoryOptions, uuid)
        this.row.jump_target_name = found ? found.category_name : ''
      },

      findCategory(list, uuid) {
        for (let i = 0; i < (list || []).length; i++) {
          if (list[i].uuid === uuid) return list[i]
          const hit = this.findCategory(list[i].children, uuid)
          if (hit) return hit
        }
        return null
      },

      loadCategories() {
        this.$api.information
          .getInformationCategorySelect()
          .then(res => {
            this.categoryOptions = res || []
            if (this.row.catetory_uuid) this.onCategoryChange(this.row.catetory_uuid)
          })
          .catch(err => this.$message.error(err))
      },

      loadInformation() {
        this.$api.information
          .getInformationList({
            search_keyword: this.informationKeyword,
            page_size: this.informationTable.per_page,
            page_index: this.informationTable.current_page
          })
          .then(res => {
            this.informationTable = res
          })
          .catch(err => this.$message.error(err))
      },
      // 搜索要回到第 1 页 —— 翻到第 3 页再输关键字，不回第 1 页搜出来的是"结果的第 3 页"，
      // 大多数时候是空的，看起来像"搜不到"
      searchInformation() {
        this.informationTable.current_page = 1
        this.loadInformation()
      },
      onInformationPage(v) {
        this.informationTable.current_page = v
        this.loadInformation()
      },
      onInformationSize(v) {
        this.informationTable.per_page = v
        this.loadInformation()
      },
      confirmInformation() {
        const picked = (this.informationTable.data || []).find(i => i.uuid === this.informationPickedUuid)
        if (!picked) return this.$message.warning('请先选一条资讯')
        this.row.information_uuid = picked.uuid
        this.row.jump_target_name = picked.information_title
        this.informationVisible = false
      },

      loadActivityPages() {
        this.$api.activityPage
          .getList({
            search_keyword: this.activityPageKeyword,
            page_size: this.activityPageTable.per_page,
            page_index: this.activityPageTable.current_page
          })
          .then(res => {
            this.activityPageTable = res
          })
          .catch(err => this.$message.error(err))
      },
      searchActivityPages() {
        this.activityPageTable.current_page = 1
        this.loadActivityPages()
      },
      onActivityPagePage(v) {
        this.activityPageTable.current_page = v
        this.loadActivityPages()
      },
      onActivityPageSize(v) {
        this.activityPageTable.per_page = v
        this.loadActivityPages()
      },
      confirmActivityPage() {
        const picked = (this.activityPageTable.data || []).find(i => i.uuid === this.activityPagePickedUuid)
        if (!picked) return this.$message.warning('请先选一个活动页')
        if (picked.uuid === this.selfPageUuid) return this.$message.warning('不能选当前正在编辑的这个页面')
        this.row.activity_page_uuid = picked.uuid
        this.row.jump_target_name = picked.title
        this.activityPageVisible = false
      }
    }
  }
</script>

<style scoped>
  .jump-config .tip {
    margin: 4px 0 0;
    line-height: 1.5;
  }
  .jump-config .picked {
    display: inline-block;
    margin-left: 10px;
    padding: 2px 10px;
    background: #f4f4f5;
    border-radius: 4px;
    color: #606266;
  }
  .avatar-uploader.video {
    width: 178px;
    height: 178px;
    position: relative;
    padding: 0;
  }
  .avatar-uploader .el-icon-delete {
    position: absolute;
    right: 6px;
    top: 6px;
    color: #fff;
    z-index: 2;
  }
</style>
